import { Inject } from '@odinjs/odin';

import { DeckAPI, DeckValue, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames, ModalRelatorioAliases } from '../../codegen';
import { Report, ReportParameters, ReportService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_RELATORIO })
export default class ModalRelatorioController extends BaseController {

  @Inject(ModalRelatorioAliases.PANEL_LOADER)
  private panelLoader: PanelAPI;

  @OnMount(ModalRelatorioAliases.DECK)
  onDeckMount({ target }: MountEvent): void {
    const { record } = this.context.getBulkData() as { record: [] };
    const api = target as DeckAPI;
    api.setData(record);
  }

  @OnSelectItem(ModalRelatorioAliases.DECK)
  onSelectItem({ item, target }: SelectItemEvent<DeckValue>): void {
    const api = target as DeckAPI;
    api.unselectAll();

    const { nrSeqBeneficiario, cdGrupo, parametrosRelatorio } = this.context.getBulkData() as unknown as ReportParameters;
    const { cdRelatorio, cdClassifRelat } = item;
    const record = [{ cdRelatorio, cdClassifRelat }] as Report[];

    this.showLoader(true);

    ReportService.openReport({ nrSeqBeneficiario, cdGrupo, parametrosRelatorio, record })
      .finally(() => this.showLoader(false));
  }

  private showLoader(visible: boolean): void {
    this.panelLoader.setVisible(visible);
  }
}
